import { Router } from './pages/router'
import { AuthRouteLayout } from './layouts/AuthRouteLayout'
import { Login } from './pages/Auth/Login'
import { SignUp } from './pages/Auth/SignUp'
import { ForgotPassword } from './pages/Auth/ForgotPassword'
import { ResetPassword } from './pages/Auth/ResetPassword'
import { AcceptInvite } from './pages/Auth/AcceptInvite'
import { TCS200 } from './pages/TCS200'
import { Organizations } from './pages/Organizations'
import { CreateOrganization } from './pages/Organizations/create'
import { EditOrganization } from './pages/Organizations/edit'
import { ProtectedRouteLayout } from './layouts/ProtectedRouteLayout'
import { NoOrganization } from "@/pages/Organizations/NoOrganization"
import { Users } from './pages/Users'
import { CreateUser } from './pages/Users/create'
import { EditUser } from './pages/Users/edit'
import { Credentials } from './pages/Credentials/Credentials'
import { CredentialsCreate } from './pages/Credentials/forms/create'
import { CredentialsEdit } from './pages/Credentials/forms/edit'
import { SelectSource as CredentialSource } from './pages/Credentials/SelectSource'
import { Workflows } from './pages/Workflows'
import { AllWorkflowsRun } from './pages/WorkflowHistory'
import { WorkflowHistory } from './pages/WorkflowHistory/WorkflowHistory'
import { WorkflowRunDetails } from './pages/WorkflowHistory/WorkflowRunDetails'
import { SupportPage } from './pages/Support'
import { MyAccount } from './pages/MyAccount'
import { Billing } from './pages/Billing'
import { WorkflowSelectSource } from './pages/Workflows/CreateWorkflow/SelectSource'
import { EditWorkflowV2 } from './pages/Workflows/CreateWorkflow/editv2'
import { CreateWorkflowV2 } from './pages/Workflows/CreateWorkflow/createv2'
import { BillingSuccess } from "@/pages/Billing/Success.tsx"
import { Dashboard } from "./pages/Dashboard"
import { DashboardList } from './pages/Dashboards'
import { DashboardCreationShell } from './pages/Dashboards/DashboardCreationShell'
import { DashboardByIdRoute } from './pages/Dashboards/DashboardByIdRoute'

const routes = [
  // auth routes
  { path: "/login", element: <AuthRouteLayout component={<Login />} /> },
  { path: "/signup", element: <AuthRouteLayout component={<SignUp />} /> },
  { path: "/forgot-password", element: <AuthRouteLayout component={<ForgotPassword />} /> },
  { path: "/reset-password", element: <AuthRouteLayout component={<ResetPassword />} /> },
  { path: "/invite", element: <AuthRouteLayout component={<AcceptInvite />} /> },
  // protected routes
  { path: "/router", element: <ProtectedRouteLayout component={<Router />} /> },
  { path: "/tcs200", element: <ProtectedRouteLayout component={<TCS200 />} /> },
  { path: "/organizations", element: <ProtectedRouteLayout component={<Organizations />} /> },
  { path: "/organizations/create", element: <ProtectedRouteLayout component={<CreateOrganization />} /> },
  { path: "/organizations/edit/:id", element: <ProtectedRouteLayout component={<EditOrganization />} /> },
  { path: "/dashboard", element: <ProtectedRouteLayout component={<Dashboard />} /> },
  { path: "/no-organization", element: <ProtectedRouteLayout component={<NoOrganization />} /> },
  { path: "/users", element: <ProtectedRouteLayout component={<Users />} /> },
  { path: "/users/create", element: <ProtectedRouteLayout component={<CreateUser />} /> },
  { path: "/users/edit/:id", element: <ProtectedRouteLayout component={<EditUser />} /> },
  { path: "/dashboards", element: <ProtectedRouteLayout component={<DashboardList />} /> },
  { path: "/dashboards/new", element: <ProtectedRouteLayout component={<DashboardCreationShell />} /> },
  { path: "/dashboards/:id", element: <ProtectedRouteLayout component={<DashboardByIdRoute />} /> },
  { path: "/workflows", element: <ProtectedRouteLayout component={<Workflows />} /> },
  { path: "/workflow-history", element: <ProtectedRouteLayout component={<AllWorkflowsRun />} /> },
  { path: "/workflow-history/:workflowId", element: <ProtectedRouteLayout component={<WorkflowHistory />} /> },
  { path: "/workflow-history/:workflowId/:runId/details", element: <ProtectedRouteLayout component={<WorkflowRunDetails />} /> },
  { path: "/workflows/select-source", element: <ProtectedRouteLayout component={<WorkflowSelectSource />} /> },
  { path: "/workflows/create", element: <ProtectedRouteLayout component={<CreateWorkflowV2 />} /> },
  { path: "/workflows/edit/:workflowId", element: <ProtectedRouteLayout component={<EditWorkflowV2 />} /> },
  { path: "/credentials", element: <ProtectedRouteLayout component={<Credentials />} /> },
  { path: "/credentials/create", element: <ProtectedRouteLayout component={<CredentialSource />} /> },
  { path: "/credentials/create/:appId", element: <ProtectedRouteLayout component={<CredentialsCreate />} /> },
  { path: "/credentials/edit/:credId", element: <ProtectedRouteLayout component={<CredentialsEdit />} /> },
  { path: "/my-account", element: <ProtectedRouteLayout component={<MyAccount />} /> },
  { path: "/billing", element: <ProtectedRouteLayout component={<Billing />} /> },
  { path: "/support", element: <ProtectedRouteLayout component={<SupportPage />} /> },
  { path: "/billing/success", element: <ProtectedRouteLayout component={<BillingSuccess />} /> },
  { path: "*", element: <Router /> }
]

export default routes
